import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";

function EditPermanentGuestListModal({ onClose, onUpdate, isOpen, listData }) {
    const [name, setName] = useState("");

    useEffect(() => {
        if (listData) {
            setName(listData.name || "");
        }
    }, [listData]);

    const handleUpdate = useCallback(() => {
        if (name.trim() && listData && listData.id) {
            onUpdate({ id: listData.id, name }); // Отправляем ID и имя списка
            onClose();
        } else {
            alert("List name cannot be empty."); // Или используйте toast для уведомлений
        }
    }, [name, onUpdate, onClose, listData]);

    const handleCloseModal = useCallback(() => {
        setName(""); // Очищаем поле при закрытии
        onClose();
    }, [onClose]);

    if (!isOpen) {
        return null;
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-96 relative">
                <button
                    onClick={handleCloseModal}
                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                    title="Close"
                >
                    ×
                </button>
                <h3 className="text-lg font-bold mb-4">Edit Guest List</h3>
                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">List Name</label>
                    <input
                        type="text"
                        className="w-full border rounded p-2 mt-1"
                        placeholder="Enter list name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>
                <div className="flex justify-center space-x-2">
                    <button
                        className="px-4 py-2 rounded bg-green-500 text-white hover:bg-green-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={handleUpdate}
                        disabled={!name.trim()}
                    >
                        Update
                    </button>
                    <button
                        className="px-4 py-2 rounded bg-gray-300 text-gray-800 hover:bg-gray-400 transition"
                        onClick={handleCloseModal}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
}

EditPermanentGuestListModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    listData: PropTypes.shape({
        id: PropTypes.any.isRequired, // или PropTypes.number, если id всегда число
        name: PropTypes.string,
        // ... другие свойства списка, если есть
    }),
};

export default EditPermanentGuestListModal;